import { Drawer, Avatar, Table, Tag, Space, Button } from 'antd'
import React, { useState, useContext } from 'react'
import { fetchData } from '../../service/dataServices';
import { useHistory } from 'react-router';
import {
  ArrowRightOutlined,
  FormOutlined,
} from '@ant-design/icons';
import { localizeField } from '../../utils/localization';
import UserContext from '../../../pages/layout/UserContext';
import checkFormTypePermission from '../../../components/Authorization/FormTypePermission';
import { useTranslation } from 'react-i18next';

function LinkDrawer({ open, setOpen, objectId }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const history = useHistory();
  const currentUser = useContext(UserContext);

  fetchData('/api/objects/links', handleResponse, { objectId: objectId }, open && !!objectId);

  function handleResponse(response) {
    if (!Array.isArray(response)) {
      console.error("LinkDrawer response is expected to be an array, but received:", response);
      setData([]);
      return;
    }
    setData(response);
  }

  const avatarStyle = { color: '#1d39c4', backgroundColor: '#f0f5ff', borderColor: '#adc6ff' }

  const getTypeLabel = (record) => {
    if (record.formName) {
      return localizeField(record.formName);
    }
    return t('linkDrawer.customReport');
  }

  const getActionButton = (item) => {
    const hasReadPerm = checkFormTypePermission(currentUser, item.formId, 'read');
    if (!hasReadPerm) return [];
    const onClick = () => {
      history.push(`/custom-form-add/${item.formId}/${item.entityId}`);
    }
    return [
      <Button key={`custom-${item.entityId}`} onClick={onClick} icon={<ArrowRightOutlined />}>
        {t('linkDrawer.view')}
      </Button>
    ];
  }

  const columns = [
    {
      title: t('linkDrawer.type'),
      dataIndex: 'entityType',
      key: 'entityType',
      render: (text, record) => (
        <Space>
          <Avatar icon={<FormOutlined />} style={avatarStyle} />
          <Tag color="geekblue">{getTypeLabel(record)}</Tag>
        </Space>
      ),
    },
    {
      title: t('linkDrawer.reportId'),
      dataIndex: 'recordId',
      key: 'recordId',
      render: text => text || '-',
    },
    {
      title: t('linkDrawer.date'),
      dataIndex: 'date',
      key: 'date',
      render: text => text || '-',
    },
    {
      title: t('linkDrawer.user'),
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: t('linkDrawer.action'),
      dataIndex: 'entityId',
      key: 'entityId',
      render: (t, object) => getActionButton(object),
    },
  ];

  return (
    <Drawer
      title={t('linkDrawer.objectLinks')}
      width={820}
      placement="right"
      size="large"
      onClose={() => setOpen(false)}
      open={open}
      styles={{
        body: { paddingBottom: 80 },
      }}
    >
      <Table dataSource={data} columns={columns} size="middle" />
    </Drawer>
  )
}

export default LinkDrawer